module.exports = __webpack_public_path__ + "static/img/gift-box-open.7fcf8e5d.png";